module.exports = __webpack_public_path__ + "static/kredobank-9285c717796e8c11ea13558113dae194.svg";